<template>
    <div>
        <b-btn
            v-if="
                authUser.permissions.find(perm => {
                    return perm.title === 'articles_edit';
                }) || authUser.authorCanEdit
            "
            v-b-modal.editArticleModal
            class="btn btn-secondary btn-sm mx-2 my-1"
        >Bearbeiten</b-btn>
        <b-btn
            v-if="
                authUser.permissions.find(perm => {
                    return perm.title === 'articles_delete';
                }) || authUser.authorCanDelete
            "
            v-b-modal.deleteArticleModal
            class="btn btn-danger btn-sm mx-2 my-1"
        >Löschen</b-btn>
        <b-modal id="editArticleModal" size="lg" no-fade>
            <template slot="modal-header">
                <h4>Artikel bearbeiten</h4>
            </template>
            <div class="form-group row">
                <div class="col-sm-9">
                    <label for="title">Titel</label>
                    <input
                        type="text"
                        class="form-control"
                        id="title"
                        placeholder="Titel"
                        v-model="editingArticle.title"
                        maxlength="45"
                    />
                </div>
                <div class="col-sm-3">
                    <label for="priority">Priorität (5 = niedrigste)</label>
                    <select
                        type="number"
                        min="1"
                        max="5"
                        class="form-control"
                        id="priority"
                        placeholder="Priorität"
                        v-model="editingArticle.priority"
                    >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                    </select>
                </div>
            </div>

            <div class="form-group" v-if="teams">
                <label for="team">
                    Mannschaft (wenn sich der Beitrag auf eine Mannschaft
                    bezieht)
                </label>
                <select class="form-control" id="team" v-model="editingArticle.team_id">
                    <option :value="null" selected>keine</option>
                    <option v-for="team in teams" :key="team.id" :value="team.id">{{ team.name }}</option>
                </select>
            </div>

            <div v-if="authUser.permissions.find(perm => { return perm.title === 'facebook_post'; })">
                <hr class="my-4" />

                <div class="form-group row">
                    <div class="col-sm-auto custom-control custom-switch ml-3">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="editFacebookInput"
                            v-model="facebook"
                        />
                        <label
                            class="custom-control-label uhe-cursor-pointer"
                            for="editFacebookInput"
                        >Auf Facebook veröffentlichen</label>
                    </div>
                    <div v-if="facebook" class="col-sm">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Optional: Beitragstext"
                            v-model="facebook_text"
                        />
                    </div>
                </div>
            </div>

            <hr class="my-4" />

            <editor :init="init" id="editor" v-model="editingArticle.article_body.body"></editor>

            <hr class="my-4" />

            <div>
                <h4 class="mb-3">
                    Anreißer
                    <small>Maximal {{ teaserMaxLength }} Zeichen.</small>
                </h4>
                <textarea
                    class="form-control"
                    rows="3"
                    v-model="editingArticle.teaser"
                    :maxlength="teaserMaxLength"
                ></textarea>
            </div>

            <hr class="my-4" />

            <div
                class="form-group"
                v-if="authUser.permissions.find(perm => {
                        return perm.title === 'images_create';
                    })"
            >
                <h4>Titelbild</h4>

                <div class="d-flex align-items-center justify-content-between mb-2">
                    <div
                        class="w-100 h-100 d-flex justify-content-center align-items-center"
                        v-if="!isLoadingCropComplete"
                    >
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else-if="editingArticle.image != undefined" class="uhe-image-div col-6">
                        <img
                            class="uhe-image"
                            :src="
                                baseUrl + 'storage/' + editingArticle.image.url
                            "
                            :alt="editingArticle.image.url"
                        />
                    </div>
                    <div v-else class="uhe-image-div">
                        <i>Keines ausgewählt.</i>
                    </div>
                    <div>
                        <b-btn
                            v-if="
                                selectingImage == false &&
                                    uploadingImage == false
                            "
                            @click="selectingImage = true"
                            class="btn uhe-image-select-button d-flex"
                        >
                            <i class="material-icons mr-1">photo_size_select_actual</i>Auswählen
                        </b-btn>
                        <b-btn
                            v-if="
                                selectingImage == false &&
                                    uploadingImage == false
                            "
                            @click="uploadingImage = true"
                            class="btn uhe-image-select-button d-flex mt-1"
                        >
                            <i class="material-icons mr-1">cloud_upload</i>Hochladen
                        </b-btn>
                        <b-btn
                            v-if="
                                selectingImage == true || uploadingImage == true
                            "
                            @click="
                                selectingImage = false;
                                uploadingImage = false;
                            "
                            class="btn uhe-image-select-button"
                        >Zuklappen</b-btn>
                    </div>
                </div>
                <image-collections
                    @selected="onSelectedImage($event)"
                    v-if="selectingImage"
                    :imagesPerRow="3"
                    :showPreviews="false"
                    :selector="true"
                    :cropper="true"
                    size="small"
                    class="mt-3"
                ></image-collections>
                <image-dropzone
                    ref="imageDropzone"
                    v-if="uploadingImage && authUser.permissions.find(perm => {
                        return perm.title === 'images_create'
                    })"
                    :multiple="false"
                    :cropper="true"
                    @selected="onSelectedImage($event)"
                ></image-dropzone>
            </div>

            <template slot="modal-footer">
                <b-button @click="saveArticle()" class="btn uhe-btn btn-sm">Speichern</b-button>
            </template>
        </b-modal>
        <b-modal id="deleteArticleModal" :title="'Den Artikel wirklich löschen?'" no-fade>
            <template slot="modal-footer">
                <b-button @click="deleteArticle()" class="btn btn-danger">Löschen</b-button>
            </template>
        </b-modal>
        <alert ref="alert" :content="alert.content" :timeout="2000"></alert>
        <alert
            ref="responseAlert"
            :content="responseAlert.content"
            :color="responseAlert.color"
            :timeout="2000"
        ></alert>
    </div>
</template>

<script>
export default {
    props: {
        article: {
            required: true
        }
    },
    data() {
        return {
            editingArticle: { content: "", article_body: { body: "" } },
            selectingImage: false,
            uploadingImage: false,
            teaserMaxLength: 150,
            init: {
                plugins: "link autolink",
                theme: "silver",
                skin_url: "/js/skins/oxide",
                contextmenu: "paste copy",
                language: "de_AT",
                language_url: "/js/de_AT.js",
                height: "500px",
                mobile: {
                    theme: "silver"
                }
            },
            authUser: { permissions: [] },
            alert: {
                show: false,
                content: ""
            },
            teams: [],
            responseAlert: {
                show: false,
                content: "",
                color: "success"
            },
            facebook: false,
            facebook_text: undefined,
            isLoadingCropComplete: true
        };
    },
    mounted() {
        this.getTeams();
        this.editingArticle = this.article;
        if (this.editingArticle.image != null)
            Vue.set(
                this.editingArticle.image,
                "url",
                this.editingArticle.image.origPath
            );
        this.getAuthUser();

        // Prevent Bootstrap dialog from blocking focusin
        document.addEventListener('focusin', function (e) {
            let closest = e.target.closest(".tox-tinymce-aux, .tox-dialog, .moxman-window, .tam-assetmanager-root");
            if (closest !== null && closest !== undefined) {
                e.stopImmediatePropagation();
            }
        });
    },
    methods: {
        getTeams() {
            window.axios.get("/teams").then(({ data }) => {
                this.teams = data;
            });
        },
        saveArticle() {
            if (
                this.editingArticle.title === undefined ||
                this.editingArticle.title === ""
            ) {
                this.alert.content = "Der Titel darf nicht leer sein!";
                this.$refs.alert.open();
                return;
            } else if (!this.editingArticle.article_body.body.length) {
                this.alert.content = "Der Textkörper darf nicht leer sein!";
                this.$refs.alert.open();
                return;
            }

            this.editingArticle.facebook = this.facebook;
            this.editingArticle.facebook_text = this.facebook_text;

            window.axios
                .put("/articles/" + this.editingArticle.id, this.editingArticle)
                .then(res => {
                    this.setResponseAlert("success", "edit");
                    window.location.replace(
                        this.baseUrl + "news/" + this.editingArticle.id
                    ); // redirect
                })
                .catch(err => {
                    if (
                        err.response.data.exception ==
                        "Facebook\\Exceptions\\FacebookResponseException"
                    )
                        this.setResponseAlert("error", "facebook");
                    this.setResponseAlert("error", "edit");
                });
            this.isLoadingComplete = false;
            this.$root.$emit("bv::hide::modal", "editArticleModal");
        },
        deleteArticle() {
            window.axios
                .delete("/articles/" + this.editingArticle.id)
                .then(res => {
                    window.location.replace(this.baseUrl + "news"); // redirect
                })
                .catch(err => {
                    this.setResponseAlert("error", "delete");
                });
            this.isLoadingComplete = false;
        },
        onSelectedImage(imgId) {
            this.isLoadingCropComplete = false;
            this.editingArticle.image = {};
            Vue.set(this.editingArticle.image, "id", imgId);

            this.getPathByImageId(imgId, url => {
                this.isLoadingCropComplete = true;
                Vue.set(this.editingArticle.image, "url", url);
            });
            this.uploadingImage = false;
            this.selectingImage = false;
        },
        getPathByImageId(id, cb) {
            window.axios.get("/images/" + id).then(({ data }) => {
                cb(data);
            });
        },
        getAuthUser() {
            window.axios.get("/authenticatedUser").then(({ data }) => {
                this.authUser = data;
                let createdAt = new Date(this.editingArticle.created_at);
                createdAt.setDate(createdAt.getDate() + 7);
                let canEdit =
                    this.editingArticle.author_id === this.authUser.id &&
                    new Date() <= createdAt;
                let canDelete =
                    this.editingArticle.author_id === this.authUser.id &&
                    new Date() <= createdAt;
                let canUploadImage =
                    this.editingArticle.author_id === this.authUser.id;
                Vue.set(this.authUser, "authorCanEdit", canEdit);
                Vue.set(this.authUser, "authorCanDelete", canDelete);
            });
        },
        setResponseAlert(code, action) {
            switch (code) {
                case "success":
                    this.responseAlert.color = "success";
                    if (action == "create")
                        this.responseAlert.content =
                            "Bericht erfolgreich angelegt";
                    else if (action == "edit")
                        this.responseAlert.content =
                            "Bericht erfolgreich aktualisiert";
                    else if (action == "delete")
                        this.responseAlert.content =
                            "Bericht erfolgreich gelöscht";

                    break;
                case "error":
                    this.responseAlert.color = "danger";
                    if (action == "create")
                        this.responseAlert.content =
                            "Fehler beim Anlegen des Berichts";
                    else if (action == "edit")
                        this.responseAlert.content =
                            "Fehler beim Aktualisieren des Berichts";
                    else if (action == "delete")
                        this.responseAlert.content =
                            "Fehler beim Löschen des Berichts";
                    else if (action == "facebook")
                        this.responseAlert.content =
                            "Fehler beim Posten auf Facebook.";
                    break;
            }

            this.$refs.responseAlert.open();
        }
    },
    computed: {
        baseUrl() {
            return window.location.origin + "/";
        }
    }
};
</script>

<style scoped>
.uhe-image {
    width: 100%;
    height: auto;
}
</style>
